import React, { useState, useEffect, useContext } from 'react'
import { IconButton, Button } from '@material-ui/core'
import moment from 'moment'
import Popup from '../../organisms/Popup'
import ReactPlayer from 'react-player'
import { Chip } from '@material-ui/core'
import ProductContext from '../../../../product/context/product/productContext'
import Icon from '@material-ui/core/Icon'
import { formatNumber } from '../../../common/components'
import Slider from 'react-slick'
import Carousel from '../../../../custom/components/molecules/Carousel'

const TrackCard = (props) => {
    const [popopen, setPopopen] = useState(false)
    const [urlvalue, setUrl] = useState('')
    const [items, setItems] = useState([])
    const {
        getTrackChart,
        updateChartmetricArtistImage,
        responseStatus: trackResponse,
    } = useContext(ProductContext)
    const [chartInfo, setChart] = useState({})

    const handleYoutube = (value) => {
        setPopopen(true)
        setUrl(value)
    }

    useEffect(() => {
        if (props.items) {
            let tmpData = props.items
            tmpData?.map((item) => {
                item.chartmetricData =
                    typeof item.chartmetricData === 'string'
                        ? JSON.parse(item.chartmetricData || '{}')
                        : item.chartmetricData || {}

                let chartmetirc_tmp =
                    item.chartmetricData && item.chartmetricData.obj ? item.chartmetricData.obj : {}
                let chartmetric =
                    item.chartmetric && item.chartmetric.obj
                        ? item.chartmetric.obj
                        : item.chartmetricData && item.chartmetricData.obj
                        ? chartmetirc_tmp
                        : {}

                item.track_image = chartmetric.image_url ? chartmetric.image_url : item.track_image
                item.track_name = chartmetric.name ? chartmetric.name : item.track_name
                item.tags = chartmetric.tags ? chartmetric.tags : 'Music'
                item.artist =
                    chartmetric.artists && chartmetric.artists.length
                        ? chartmetric.artists[0]['name']
                        : item.artist
                item.artist_id =
                    chartmetric.artists && chartmetric.artists.length
                        ? chartmetric.artists[0]['id']
                        : item.artist_id
                item.release_date = chartmetric.release_date
                    ? chartmetric.release_date
                    : item.track_image
                item.track_details = chartmetric.cm_statistics ? chartmetric.cm_statistics : {}

                item.updateChartmetricData =
                    JSON.stringify(chartmetric) != JSON.stringify(item.chartmetricData)
                        ? true
                        : false

                if (chartmetric) {
                    if (JSON.stringify(chartmetric) != JSON.stringify(chartmetirc_tmp)) {
                        updateChartmetricArtistImage(
                            {
                                project_id: item.project_id,
                                track_id: item.track_id,
                                chartmetricData: item.chartmetric,
                            },
                            true,
                        )
                    }

                    if (
                        chartmetric.artists &&
                        !chartmetric.artists[0].image_url &&
                        !item.artist_image
                    ) {
                        getTrackChart({
                            track_id: chartmetric.id,
                            artist_id: chartmetric.artists[0].id,
                            otherData: '',
                        })
                    }
                }

                return item
            })
            //setItems(props.items)
            setItems(tmpData)
        }
    }, [props.items])

    useEffect(() => {
        if (trackResponse) {
            if (trackResponse.from === 'track_chart') {
                if (trackResponse.status === 'success') {
                    let tmpData = items
                    tmpData.map((item, index) => {
                        if (
                            trackResponse.data.info &&
                            trackResponse.data.info.obj &&
                            trackResponse.data.info.obj.id == item.track_id &&
                            trackResponse.data.artist
                        ) {
                            if (
                                item.chartmetric &&
                                item.chartmetric.obj &&
                                item.chartmetric.obj.artists
                            ) {
                                tmpData[index].chartmetric.obj.artists[0].image_url = trackResponse
                                    .data.artist.image_url
                                    ? trackResponse.data.artist.image_url
                                    : item.artist_image
                                    ? item.artist_image
                                    : item.chartmetric.obj.image_url

                                if (
                                    !item.artist_image ||
                                    (!item.chartmetric.obj.artists[0].image_url &&
                                        item.chartmetric.obj.artists[0].image_url !=
                                            item.artist_image)
                                ) {
                                    updateChartmetricArtistImage(
                                        {
                                            project_id: item.project_id,
                                            track_id: item.track_id,
                                            artist_image: item.chartmetric.obj.artists[0].image_url,
                                        },
                                        true,
                                    )

                                    item.artist_image = item.chartmetric.obj.artists[0].image_url
                                }
                            }
                        }
                    })
                }
            }
        }
    }, [trackResponse])

    useEffect(() => {
        if (trackResponse && 1 == 2) {
            if (trackResponse.from === 'track_chart') {
                if (trackResponse.status === 'success') {
                    //setChart(trackResponse.data)
                    // let updatedImageData = []

                    let tmpData = props.items
                    tmpData.map((item, index) => {
                        let updatedChartmetricData = []
                        updatedChartmetricData['track_' + item.track_id] = {
                            project_id: item.project_id,
                            track_id: item.track_id,
                            updateChartmetricData: item.updateChartmetricData,
                        }

                        if (item.chartmetric && item.chartmetric.obj) {
                            updatedChartmetricData['track_' + item.track_id].chartmetricData =
                                item.chartmetric.obj
                        }

                        if (
                            trackResponse.data.info &&
                            trackResponse.data.info.obj &&
                            trackResponse.data.info.obj.id == item.track_id &&
                            trackResponse.data.artist
                        ) {
                            if (
                                item.chartmetric &&
                                item.chartmetric.obj &&
                                item.chartmetric.obj.artists
                            ) {
                                //item.chartmetric.obj.artists[0].image_url = trackResponse.data
                                tmpData[index].chartmetric.obj.artists[0].image_url = trackResponse
                                    .data.artist.image_url
                                    ? trackResponse.data.artist.image_url
                                    : item.artist_image
                                    ? item.artist_image
                                    : item.chartmetric.obj.image_url

                                /* tmpData[index].chartmetric.obj.artists[0].image_url = trackResponse
                                    .data.artist.image_url
                                    ? trackResponse.data.artist.image_url
                                    : item.chartmetric.obj.image_url */

                                if (
                                    !item.artist_image ||
                                    (!item.chartmetric.obj.artists[0].image_url &&
                                        item.chartmetric.obj.artists[0].image_url !=
                                            item.artist_image)
                                ) {
                                    /* updatedImageData.push({
                                        project_id: item.project_id,
                                        artist_image: item.chartmetric.obj.artists[0].image_url,
                                        track_id: item.track_id,
                                    }) */
                                    updatedChartmetricData[
                                        'track_' + item.track_id
                                    ].updateChartmetricData = true
                                    updatedChartmetricData['track_' + item.track_id].artist_image =
                                        item.chartmetric.obj.artists[0].image_url
                                    tmpData[index].artist_image =
                                        item.chartmetric.obj.artists[0].image_url
                                }

                                //return item
                            }
                        }

                        if (
                            updatedChartmetricData.length > 0 ||
                            Object.keys(updatedChartmetricData).length > 0
                        ) {
                            Object.keys(updatedChartmetricData).map((key) => {
                                if (updatedChartmetricData[key].updateChartmetricData) {
                                    updatedChartmetricData[key].updateChartmetricData = true
                                    updateChartmetricArtistImage(updatedChartmetricData[key], true)
                                }
                            })
                        }
                    })

                    setItems(tmpData)
                }
            }
        }
    }, [trackResponse])
    const {} = props

    return (
        <>
            {items && items.length > 0 && (
                <Carousel
                    heading={props?.heading ?? 'Track Details'}
                    slides={items}
                    render={(data, index) => (
                        <div className="trackDetailCard" key={index}>
                            <div className="videoPlayer">
                                {data.youtube_link !== '' ? (
                                    <ReactPlayer
                                        url={data.youtube_link}
                                        width="100%"
                                        height="100%"
                                    />
                                ) : data?.youtube_link == '' ? (
                                    <div className="noImgWrpr">
                                        <img
                                            className
                                            src="/assets/images/novideo.png"
                                            width="100%"
                                            height="100%"
                                        />
                                    </div>
                                ) : (
                                    <div className="noImgWrpr">
                                        <img
                                            className
                                            src="/assets/images/novideo.png"
                                            width="100%"
                                            height="100%"
                                        />
                                    </div>
                                )}
                            </div>
                            <div className="trackDetailsCardPlays">
                                <div
                                    className="trackDetails cursorDecoy"
                                    onClick={() => props.handleClose(index)}
                                >
                                    <img
                                        onError={(e) => (e.src = '/assets/images/noImg.png')}
                                        src={
                                            data.track_image
                                                ? data.track_image
                                                : global.images_url + '/assets/images/noImg.png'
                                        }
                                    />
                                    <div className="trackTitles">
                                        <h5>{data.track_name}</h5>
                                        <span>{data.artist}</span>
                                        <span>
                                            {moment(data.release_date).format('YYYY-MM-DD')}
                                        </span>
                                    </div>
                                </div>
                                <div
                                    className="trackDetails cursorPointer"
                                    onClick={() => props.handleClose(index)}
                                >
                                    <img
                                        onError={(e) => (e.src = '/assets/images/noImg.png')}
                                        src={
                                            data.artist_image
                                                ? data.artist_image
                                                : data.chartmetric &&
                                                  data.chartmetric.obj &&
                                                  data.chartmetric.obj.artists[0].image_url
                                                ? data.chartmetric.obj.artists[0].image_url
                                                : '/assets/images/noImg.png'
                                        }
                                    />
                                    <div className="trackTitles">
                                        <h5>{data.artist}</h5>
                                        <span>{'Artist'}</span>
                                        <div className="icnStk">
                                            <IconButton
                                                className="m-0 p-0"
                                                onClick={() => props.handleClose(index)}
                                            >
                                                <img
                                                    className="shareImg"
                                                    src="/assets/images/chartmetric.png"
                                                />
                                            </IconButton>
                                            <IconButton
                                                className="m-0 p-0"
                                                onClick={() =>
                                                    window.open(data.insta_link, '__blank')
                                                }
                                            >
                                                <img
                                                    className="shareImg"
                                                    src="/assets/images/instagram.png"
                                                />
                                            </IconButton>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="trackDetailsCardBottom">
                                <div className="trackBottomCnt">
                                    <img src="/assets/svg/spotify.svg" />
                                    <div>
                                        <h5 style={{ color: '#3abd59' }}>
                                            {formatNumber(
                                                data.track_details.streams ||
                                                    data.track_details.sp_streams,
                                                'N/A',
                                            )}
                                        </h5>
                                        <span>{'Streams'}</span>
                                    </div>
                                </div>
                                <div className="trackBottomCnt">
                                    <img src="/assets/svg/youtube_icon.svg" />
                                    <div>
                                        <h5 style={{ color: '#f50103' }}>
                                            {formatNumber(data.track_details.youtube_views, 'N/A')}
                                        </h5>
                                        <span>{'Views'}</span>
                                    </div>
                                </div>
                                <div className="trackBottomCnt">
                                    <img src="/assets/svg/pandora_icon.svg" />
                                    <div>
                                        <h5 style={{ color: '#3089f5' }}>
                                            {formatNumber(
                                                data.track_details.pandora_lifetime_streams,
                                                'N/A',
                                            )}
                                        </h5>
                                        <span>{'Streams'}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                />
            )}
            <Popup
                cstmModalClass="maxWdPopup"
                modaltitle={'Songvest'}
                open={popopen}
                handleClose={() => setPopopen(false)}
            >
                <iframe src={urlvalue} width="650" height="400"></iframe>
            </Popup>
        </>
    )
}

export default TrackCard
